<section class="login-shell">
  <p class="login-intro">
    Choral database for Revel, a Czech choir specializing in Renaissance music. It contains information about composers, songs, revels and other choir resources.
  </p>
  <mat-card class="login-card">
    <mat-card-title class="small-title">Login</mat-card-title>
    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">
        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" autocomplete="username" />
          <mat-error *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            Email is required and must be valid.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" autocomplete="current-password" />
          <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            Password is required.
          </mat-error>
        </mat-form-field>

        <p class="error-text" *ngIf="error">{{ error }}</p>

        <div class="form-actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid">Login</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</section>
